define('components/utils/models/guid',[], function () {
    "use strict";

    return {
        "_guidList": [],

        "generate": function () {
            var guid,
                replaceFunc;

            // Generate GUID as per the RFC4122 version 4 spec
            // https://tools.ietf.org/html/rfc4122
            // http://www.cryptosys.net/pki/uuid-rfc4122.html

            replaceFunc = function (c) {
                var r, v;

                // generate random hex-byte and drop fractional portion
                r = Math.random() * 16 | 0;

                if (c === 'x') {
                    // Not the 9th byte
                    v = r;
                } else {
                    // set the two most significant bits of the 9th byte so the high nibble will be one of '8', '9', 'A', or 'B'
                    v = r & 0x3 | 0x8;
                }

                // return the hexadecimal equivalent of the byte
                return v.toString(16);
            };

            do {
                guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, replaceFunc);
            } while (this._guidList.indexOf(guid) > -1)

            this._guidList.push(guid);

            return guid;
        },

        "isValid": function (guid) {
            // Validate GUID as per the RFC4122 version 4 spec
            // https://tools.ietf.org/html/rfc4122
            // http://www.cryptosys.net/pki/uuid-rfc4122.html
            return /^[a-f\d]{8}-[a-f\d]{4}-4[a-f\d]{3}-[89ab][a-f\d]{3}-[a-f\d]{12}$/i.test(guid);
        }
    };
});

